import { render, staticRenderFns } from "./ehc-btn.vue?vue&type=template&id=2fab0a38"
import script from "./ehc-btn.vue?vue&type=script&lang=js"
export * from "./ehc-btn.vue?vue&type=script&lang=js"
import style0 from "./ehc-btn.vue?vue&type=style&index=0&id=2fab0a38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports